import React, { useState } from "react";
import { DocWrapper, ExpandableCard } from "./DocStyles";

export default function BookingLifecycle() {
  const [openCards, setOpenCards] = useState({ 0: true, 1: true, 2: true });

  const toggleCard = (index) => {
    setOpenCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <DocWrapper>
      <div className="header">
        <h1>Booking Lifecycle & Approval Process</h1>
        <div className="tagline">Buddy4Travel — End-to-End Booking State Machine</div>
        <div className="subtitle">Initiation · Matching · Assignment · Execution · Settlement</div>
      </div>

      <div className="card" style={{ padding: "12px" }}>
        <svg viewBox="0 0 1000 780" xmlns="http://www.w3.org/2000/svg" style={{ background: "#ffffff" }}>
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#f0f0f0" strokeWidth="0.5"/>
            </pattern>
            <marker id="arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#6b7280"/>
            </marker>
            <marker id="arrow-cyan" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#004d2c"/>
            </marker>
            <marker id="arrow-emerald" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#059669"/>
            </marker>
            <marker id="arrow-rose" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#f43f5e"/>
            </marker>
            <marker id="arrow-amber" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#f59e0b"/>
            </marker>
          </defs>

          <rect width="1000" height="780" fill="#fafafa"/>

          <text x="60" y="55" fill="#6b7280" fontSize="10" fontWeight="bold">PHASE 1 — INITIATION</text>
          <text x="60" y="260" fill="#6b7280" fontSize="10" fontWeight="bold">PHASE 2 — MATCHING</text>
          <text x="60" y="460" fill="#6b7280" fontSize="10" fontWeight="bold">PHASE 3 — ASSIGNMENT</text>
          <text x="60" y="660" fill="#6b7280" fontSize="10" fontWeight="bold">PHASE 4 — JOURNEY &amp; SETTLEMENT</text>

          <rect x="40" y="70" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="40" y="70" width="200" height="55" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="140" y="95" textAnchor="middle" fill="#004d2c" fontSize="11" fontWeight="bold">1. Booking Initiated</text>
          <text x="140" y="111" textAnchor="middle" fill="#6b7280" fontSize="8">Care Seeker enters flight</text>
          <text x="140" y="119" textAnchor="middle" fill="#6b7280" fontSize="8">details + preferences</text>

          <path d="M 240 97 L 280 97" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="280" y="70" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="280" y="70" width="200" height="55" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="380" y="95" textAnchor="middle" fill="#004d2c" fontSize="11" fontWeight="bold">2. Payment via Stripe</text>
          <text x="380" y="111" textAnchor="middle" fill="#6b7280" fontSize="8">Payment Intent created</text>
          <text x="380" y="119" textAnchor="middle" fill="#6b7280" fontSize="8">Card/wallet payment processed</text>

          <path d="M 480 97 L 520 97" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="520" y="70" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="520" y="70" width="200" height="55" rx="6" fill="rgba(0,77,44,0.06)" stroke="#059669" strokeWidth="1.5"/>
          <text x="620" y="95" textAnchor="middle" fill="#059669" fontSize="11" fontWeight="bold">3. Payment Confirmed</text>
          <text x="620" y="111" textAnchor="middle" fill="#6b7280" fontSize="8">booking_request_initiated</text>
          <text x="620" y="119" textAnchor="middle" fill="#6b7280" fontSize="8">Trail + OTP created</text>

          <path d="M 720 97 L 760 97" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="760" y="70" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="760" y="70" width="200" height="55" rx="6" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1.5"/>
          <text x="860" y="95" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold">4. On Matchboard</text>
          <text x="860" y="111" textAnchor="middle" fill="#6b7280" fontSize="8">Care Seeker visible to</text>
          <text x="860" y="119" textAnchor="middle" fill="#6b7280" fontSize="8">all available Carers</text>

          <path d="M 860 125 L 860 180 L 140 180 L 140 215" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)" strokeDasharray="6,3"/>

          <rect x="40" y="215" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="40" y="215" width="200" height="55" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="140" y="240" textAnchor="middle" fill="#004d2c" fontSize="11" fontWeight="bold">5. Carer Sees Request</text>
          <text x="140" y="256" textAnchor="middle" fill="#6b7280" fontSize="8">Matchboard match by route</text>
          <text x="140" y="264" textAnchor="middle" fill="#6b7280" fontSize="8">date, flight, plan type</text>

          <path d="M 240 242 L 280 242" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="280" y="215" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="280" y="215" width="200" height="55" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="380" y="240" textAnchor="middle" fill="#004d2c" fontSize="11" fontWeight="bold">6. Booking Request Sent</text>
          <text x="380" y="256" textAnchor="middle" fill="#6b7280" fontSize="8">Carer accepts via app</text>
          <text x="380" y="264" textAnchor="middle" fill="#6b7280" fontSize="8">Overlap check passes</text>

          <path d="M 480 242 L 520 242" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="520" y="215" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="520" y="215" width="200" height="55" rx="6" fill="rgba(0,77,44,0.06)" stroke="#059669" strokeWidth="1.5"/>
          <text x="620" y="240" textAnchor="middle" fill="#059669" fontSize="11" fontWeight="bold">7. Accepted by Carer</text>
          <text x="620" y="256" textAnchor="middle" fill="#6b7280" fontSize="8">accepted_by_carer</text>
          <text x="620" y="264" textAnchor="middle" fill="#6b7280" fontSize="8">Pending admin confirmation</text>

          <path d="M 620 270 L 620 300 L 860 300 L 860 330" fill="none" stroke="#f43f5e" strokeWidth="1" strokeDasharray="6,3" markerEnd="url(#arrow-rose)"/>
          <rect x="770" y="290" width="190" height="25" rx="4" fill="#ffffff"/>
          <rect x="770" y="290" width="190" height="25" rx="4" fill="rgba(136, 19, 55, 0.05)" stroke="#f43f5e" strokeWidth="1"/>
          <text x="865" y="306" textAnchor="middle" fill="#f43f5e" fontSize="9">Admin rejects → Re-opens matchboard</text>

          <path d="M 620 270 L 620 315" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="40" y="315" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="40" y="315" width="200" height="55" rx="6" fill="rgba(251, 146, 60, 0.06)" stroke="#fb923c" strokeWidth="1.5"/>
          <text x="140" y="340" textAnchor="middle" fill="#fb923c" fontSize="11" fontWeight="bold">8. Admin Review</text>
          <text x="140" y="356" textAnchor="middle" fill="#6b7280" fontSize="8">Admin Dashboard review</text>
          <text x="140" y="364" textAnchor="middle" fill="#6b7280" fontSize="8">of Carer acceptance</text>

          <path d="M 240 342 L 280 342" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="280" y="315" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="280" y="315" width="200" height="55" rx="6" fill="rgba(0,77,44,0.06)" stroke="#059669" strokeWidth="1.5"/>
          <text x="380" y="340" textAnchor="middle" fill="#059669" fontSize="11" fontWeight="bold">9. Carer Assigned</text>
          <text x="380" y="356" textAnchor="middle" fill="#6b7280" fontSize="8">carer_assigned</text>
          <text x="380" y="364" textAnchor="middle" fill="#6b7280" fontSize="8">Chat enabled + Checklist generated</text>

          <path d="M 480 342 L 520 342" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="520" y="315" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="520" y="315" width="200" height="55" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="620" y="340" textAnchor="middle" fill="#004d2c" fontSize="11" fontWeight="bold">10. Notifications Sent</text>
          <text x="620" y="356" textAnchor="middle" fill="#6b7280" fontSize="8">Push to both parties</text>
          <text x="620" y="364" textAnchor="middle" fill="#6b7280" fontSize="8">Email confirmation sent</text>

          <path d="M 720 342 L 760 342" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="760" y="315" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="760" y="315" width="200" height="55" rx="6" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1.5"/>
          <text x="860" y="340" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold">11. Trip Ready</text>
          <text x="860" y="356" textAnchor="middle" fill="#6b7280" fontSize="8">Care Seeker + Carer</text>
          <text x="860" y="364" textAnchor="middle" fill="#6b7280" fontSize="8">connected and ready</text>

          <path d="M 860 370 L 860 420 L 140 420 L 140 460" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)" strokeDasharray="6,3"/>

          <rect x="40" y="460" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="40" y="460" width="200" height="55" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="140" y="485" textAnchor="middle" fill="#004d2c" fontSize="11" fontWeight="bold">12. Trip Execution</text>
          <text x="140" y="501" textAnchor="middle" fill="#6b7280" fontSize="8">Carer meets + OTP verified</text>
          <text x="140" y="509" textAnchor="middle" fill="#6b7280" fontSize="8">Journey stages tracked live</text>

          <path d="M 240 487 L 280 487" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="280" y="460" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="280" y="460" width="200" height="55" rx="6" fill="rgba(0,77,44,0.06)" stroke="#059669" strokeWidth="1.5"/>
          <text x="380" y="485" textAnchor="middle" fill="#059669" fontSize="11" fontWeight="bold">13. Trip Completed</text>
          <text x="380" y="501" textAnchor="middle" fill="#6b7280" fontSize="8">completed</text>
          <text x="380" y="509" textAnchor="middle" fill="#6b7280" fontSize="8">Care Seeker rates + reviews</text>

          <path d="M 480 487 L 520 487" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="520" y="460" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="520" y="460" width="200" height="55" rx="6" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1.5"/>
          <text x="620" y="485" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold">14. Settlement</text>
          <text x="620" y="501" textAnchor="middle" fill="#6b7280" fontSize="8">Admin triggers distribute</text>
          <text x="620" y="509" textAnchor="middle" fill="#6b7280" fontSize="8">Carer paid via Stripe payout</text>

          <path d="M 720 487 L 760 487" fill="none" stroke="#6b7280" strokeWidth="1.5" markerEnd="url(#arrow)"/>

          <rect x="760" y="460" width="200" height="55" rx="6" fill="#ffffff"/>
          <rect x="760" y="460" width="200" height="55" rx="6" fill="rgba(76, 29, 149, 0.06)" stroke="#a78bfa" strokeWidth="1.5"/>
          <text x="860" y="485" textAnchor="middle" fill="#a78bfa" fontSize="11" fontWeight="bold">15. Done</text>
          <text x="860" y="501" textAnchor="middle" fill="#6b7280" fontSize="8">amount_distribute</text>
          <text x="860" y="509" textAnchor="middle" fill="#6b7280" fontSize="8">Audit trail complete</text>

          <text x="60" y="565" fill="#f43f5e" fontSize="10" fontWeight="bold">CANCELLATION FLOW</text>

          <rect x="40" y="580" width="160" height="45" rx="6" fill="#ffffff"/>
          <rect x="40" y="580" width="160" height="45" rx="6" fill="rgba(136, 19, 55, 0.06)" stroke="#f43f5e" strokeWidth="1.5"/>
          <text x="120" y="600" textAnchor="middle" fill="#f43f5e" fontSize="10" fontWeight="bold">Cancel Requested</text>
          <text x="120" y="616" textAnchor="middle" fill="#6b7280" fontSize="8">cancellation_pending</text>

          <path d="M 200 602 L 240 602" fill="none" stroke="#f43f5e" strokeWidth="1.5" markerEnd="url(#arrow-rose)"/>

          <rect x="240" y="580" width="160" height="45" rx="6" fill="#ffffff"/>
          <rect x="240" y="580" width="160" height="45" rx="6" fill="rgba(136, 19, 55, 0.06)" stroke="#f43f5e" strokeWidth="1.5"/>
          <text x="320" y="600" textAnchor="middle" fill="#f43f5e" fontSize="10" fontWeight="bold">Admin Approves</text>
          <text x="320" y="616" textAnchor="middle" fill="#6b7280" fontSize="8">cancellation_accepted</text>

          <path d="M 400 602 L 440 602" fill="none" stroke="#f43f5e" strokeWidth="1.5" markerEnd="url(#arrow-rose)"/>

          <rect x="440" y="580" width="160" height="45" rx="6" fill="#ffffff"/>
          <rect x="440" y="580" width="160" height="45" rx="6" fill="rgba(136, 19, 55, 0.06)" stroke="#f43f5e" strokeWidth="1.5"/>
          <text x="520" y="600" textAnchor="middle" fill="#f43f5e" fontSize="10" fontWeight="bold">Refund Via Stripe</text>
          <text x="520" y="616" textAnchor="middle" fill="#6b7280" fontSize="8">Full or partial refund</text>

          <path d="M 600 602 L 640 602" fill="none" stroke="#f43f5e" strokeWidth="1.5" markerEnd="url(#arrow-rose)"/>

          <rect x="640" y="580" width="160" height="45" rx="6" fill="#ffffff"/>
          <rect x="640" y="580" width="160" height="45" rx="6" fill="rgba(136, 19, 55, 0.06)" stroke="#f43f5e" strokeWidth="1.5"/>
          <text x="720" y="600" textAnchor="middle" fill="#f43f5e" fontSize="10" fontWeight="bold">Cancel Complete</text>
          <text x="720" y="616" textAnchor="middle" fill="#6b7280" fontSize="8">cancellation_completed</text>

          <path d="M 720 625 L 720 650 L 860 650 L 860 125" fill="none" stroke="#f43f5e" strokeWidth="1" strokeDasharray="3,3" markerEnd="url(#arrow-rose)"/>

          <rect x="40" y="695" width="920" height="65" rx="8" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1"/>
          <text x="60" y="712" fill="#6b7280" fontSize="9">Legend</text>
          <rect x="60" y="720" width="14" height="8" rx="2" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1"/>
          <text x="80" y="729" fill="#4b5563" fontSize="8">Care Seeker Action</text>
          <rect x="230" y="720" width="14" height="8" rx="2" fill="rgba(0,77,44,0.06)" stroke="#059669" strokeWidth="1"/>
          <text x="250" y="729" fill="#4b5563" fontSize="8">System Event</text>
          <rect x="390" y="720" width="14" height="8" rx="2" fill="rgba(251, 146, 60, 0.06)" stroke="#fb923c" strokeWidth="1"/>
          <text x="410" y="729" fill="#4b5563" fontSize="8">Admin Action</text>
        </svg>
      </div>

      <div className="grid-cards">
        <div className="card">
          <div className="card-header"><div className="card-dot cyan"></div><h3>Phase 1: Initiation</h3></div>
          <ul>
            <li><strong>Who:</strong> Care Seeker in Consumer Mobile App</li>
            <li><strong>Action:</strong> Stripe payment → Booking created</li>
            <li><strong>Output:</strong> Care Seeker visible on Matchboard</li>
          </ul>
        </div>
        <div className="card">
          <div className="card-header"><div className="card-dot amber"></div><h3>Phase 2-3: Matching</h3></div>
          <ul>
            <li><strong>Carer:</strong> Finds via matchboard → Sends Request</li>
            <li><strong>Admin:</strong> Reviews in Dashboard → Assigns</li>
          </ul>
        </div>
        <div className="card">
          <div className="card-header"><div className="card-dot violet"></div><h3>Phase 4: Execution</h3></div>
          <ul>
            <li><strong>Journey:</strong> OTP start → Live stages → End</li>
            <li><strong>Settlement:</strong> Admin triggers distribute → Carer paid</li>
          </ul>
        </div>
      </div>

      <ExpandableCard onClick={() => toggleCard(0)}>
        <div className="card-header clickable">
          <span className="card-dot cyan"></span><h3>Booking State Transitions</h3>
        </div>
        <div className={`card-body ${openCards[0] ? 'open' : 'collapsed'}`}>
          <table>
            <thead>
              <tr><th>Status</th><th>Description</th><th>Who Triggers</th></tr>
            </thead>
            <tbody>
              <tr><td>booking_request_initiated</td><td>Payment started</td><td>Stripe</td></tr>
              <tr><td>carer_assigned</td><td>Admin confirmed</td><td>Admin</td></tr>
              <tr><td>completed</td><td>Trip ended</td><td>Carer</td></tr>
              <tr><td>amount_distribute</td><td>Carer paid</td><td>Admin</td></tr>
            </tbody>
          </table>
        </div>
      </ExpandableCard>
    </DocWrapper>
  );
}
